










































import { Vue, Component, Prop, Emit } from "vue-property-decorator"
import SelectArticlesDialog from "@/components/SpecialFeatures/SelectArticlesDialog.vue"
import { ArticleSearchMaster, SearchResultArticle } from "types/index"
import { DataTableHeader } from "vuetify/types"

@Component({
  components: { SelectArticlesDialog },
})
export default class Articles extends Vue {
  get headers(): DataTableHeader[] {
    return [
      { text: "ID", value: "id" },
      { text: "タイトル", value: "title" },
      { text: "ライター", value: "writer" },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  @Prop()
  private readonly!: boolean
  @Prop()
  private articles!: SearchResultArticle[]
  @Prop()
  private articleSearchMaster!: ArticleSearchMaster["searchMaster"]

  private showDialog = false
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: -1,
  }

  public show(): void {
    this.showDialog = true
  }

  public hide(): void {
    this.showDialog = false
    const selectArticle = this.$refs.selectArticle as InstanceType<
      typeof SelectArticlesDialog
    >
    selectArticle.clear()
  }

  public ok(articles: SearchResultArticle[]): void {
    if (articles.length > 0) {
      this.emitArticles(articles)
    }
    this.hide()
  }

  public cancel(): void {
    this.hide()
  }

  @Emit("emitArticles")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitArticles(articles: SearchResultArticle[]) {
    /* */
  }

  @Emit("emitRemoveArticleId")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitRemoveArticleId(articleId: number) {
    /* */
  }
}
